// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sub-img-style[data-v-4f99280e] {\n    /* background-color: #000066 !important; */\n    background-size: cover;\n    padding: 200px 0;\n    background-color: rgb(242 245 255 / 60%);\n    background-blend-mode: multiply;\n    background-position: center;\n}\n.form-control[data-v-4f99280e]:focus {\n    border: 1px solid #06b1d8 !important\n}\n", ""]);
// Exports
module.exports = exports;
